import { render, staticRenderFns } from "./StatisticsLicenseBook.vue?vue&type=template&id=96a62e8a&scoped=true"
import script from "./StatisticsLicenseBook.vue?vue&type=script&lang=ts"
export * from "./StatisticsLicenseBook.vue?vue&type=script&lang=ts"
import style0 from "./StatisticsLicenseBook.vue?vue&type=style&index=0&id=96a62e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a62e8a",
  null
  
)

export default component.exports